import { msg } from "@lingui/core/macro";

export const startBeforeExpiryRuleMessages = {
	name: msg({ message: "Start Before Expiry" }),
	description: msg({ message: "Start must be before expiry" }),
	errors: {
		isAfter: msg({ message: "Start must be before expiry" }),
	},
} as const;
